export default {
  type: 'object',
  properties: {
    selectedSchool: {
      type: 'string',
      title: 'Wybierz szkołę/kolegium/ośrodek/zespół szkół/centrum kształcenia',
      fieldRequired: true
    },
    selectedSubschool: {
      type: 'string',
      title: 'Wybierz szkołę/kolegium wchodzące w skład zespołu szkół/ośrodka/centrum',
      fieldRequired: true
    }
  }
};
